import { authRoutes } from "./_authRoutes";
import { profileRoutes } from "./_profileRoutes";
import { newsRoutes } from "./_newsRoutes";
import { feedRoutes } from "./_feedRoutes";
import { challengeRoutes } from "./_challengeRoutes";
import { teamRoutes } from "./_teamRoutes";
import { zoneRoutes } from "./_zoneRoutes";
import { eventRoutes } from "./_eventRoutes";
import { miscRoutes } from "./_miscRoutes";
import { adminRoutes } from "./_adminRoutes";
import { treasurehuntRoutes } from "./_treasurehuntRoutes";
import { precisionGameRoutes } from "./_precisionGameRoutes";
import { raffleRoutes } from "./_raffleRoutes";
import { redirectRoutes } from "./_redirectRoutes";

export const loggedInRoutes: {
  element: (() => JSX.Element) | React.FunctionComponent;
  path: string;
}[] = [
  ...adminRoutes,
  ...authRoutes,
  ...profileRoutes,
  ...newsRoutes,
  ...feedRoutes,
  ...challengeRoutes,
  ...teamRoutes,
  ...zoneRoutes,
  ...eventRoutes,
  ...treasurehuntRoutes,
  ...precisionGameRoutes,
  ...raffleRoutes,
  ...miscRoutes,
  ...redirectRoutes,
];
